export enum EvaluationStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CORRECTION_COMPLETE = 'correction_complete',
}